import React, { useState } from 'react';

function getFilename(pageMode, customTitle, ext) {
  const modeLabel = pageMode === 'poem' ? '古诗字帖' : '汉字字帖';
  const title = customTitle.trim();
  if (title) return `${modeLabel}-${title}`;
  return modeLabel;
}

const ExportPanel = ({ gridRef, characterCount, pageMode, customTitle }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleExportPDF = async () => {
    if (!gridRef?.current || characterCount === 0) return;
    setIsExporting(true);
    try {
      const { exportToPDF } = await import('../utils/pdfExporter');
      await exportToPDF(gridRef.current, {
        filename: getFilename(pageMode, customTitle, 'pdf'),
        pageSize: 'a4',
        orientation: 'portrait',
        margin: 0,
        scale: 2
      });
    } catch (error) {
      alert(error.message || '导出失败，请重试');
    } finally {
      setIsExporting(false);
      setIsOpen(false);
    }
  };

  const handleExportPNG = async () => {
    if (!gridRef?.current || characterCount === 0) return;
    setIsExporting(true);
    try {
      const { exportToPNG } = await import('../utils/pdfExporter');
      await exportToPNG(gridRef.current, {
        filename: getFilename(pageMode, customTitle, 'png'),
        scale: 2
      });
    } catch (error) {
      alert(error.message || '导出失败，请重试');
    } finally {
      setIsExporting(false);
      setIsOpen(false);
    }
  };

  const handlePrint = () => {
    if (!gridRef?.current || characterCount === 0) return;
    import('../utils/pdfExporter').then(({ printPreview }) => {
      printPreview(gridRef.current);
      setIsOpen(false);
    });
  };

  return (
    <div className="export-dropdown">
      <button
        className="nav-btn"
        onClick={() => setIsOpen(prev => !prev)}
        disabled={characterCount === 0 || isExporting}
      >
        {isExporting ? '处理中...' : '导出 ▾'}
      </button>
      {isOpen && (
        <div className="export-menu">
          <button onClick={handleExportPDF}>导出 PDF</button>
          <button onClick={handleExportPNG}>导出图片</button>
          <button onClick={handlePrint}>打印</button>
        </div>
      )}
    </div>
  );
};

export default ExportPanel;
